import { create } from 'zustand'
import { config } from '../config'

type HeadState = {
  /** 已平滑（EMA）的姿态，单位 弧度 */
  yaw: number
  pitch: number
  roll: number
  /** 校准偏移量 */
  calibration: { yaw: number; pitch: number; roll: number }
  /** 头部追踪是否在工作 */
  active: boolean
  lastUpdateMs: number

  ingest: (yaw: number, pitch: number, roll: number) => void
  calibrate: () => void
  resetCalibration: () => void
  setActive: (a: boolean) => void
}

const _emaState = { yaw: 0, pitch: 0, roll: 0 }

export const useHeadStore = create<HeadState>((set, get) => ({
  yaw: 0,
  pitch: 0,
  roll: 0,
  calibration: { yaw: 0, pitch: 0, roll: 0 },
  active: false,
  lastUpdateMs: 0,

  ingest: (rawYaw, rawPitch, rawRoll) => {
    const a = config.head.emaAlpha
    _emaState.yaw = a * rawYaw + (1 - a) * _emaState.yaw
    _emaState.pitch = a * rawPitch + (1 - a) * _emaState.pitch
    _emaState.roll = a * rawRoll + (1 - a) * _emaState.roll

    const cal = get().calibration
    set({
      yaw: _emaState.yaw - cal.yaw,
      pitch: _emaState.pitch - cal.pitch,
      roll: _emaState.roll - cal.roll,
      active: true,
      lastUpdateMs: performance.now(),
    })
  },

  calibrate: () =>
    set({
      calibration: {
        yaw: _emaState.yaw,
        pitch: _emaState.pitch,
        roll: _emaState.roll,
      },
    }),
  resetCalibration: () => set({ calibration: { yaw: 0, pitch: 0, roll: 0 } }),
  setActive: (a) => set({ active: a }),
}))
